import type { ReactNode } from 'react';

type Props = { children: ReactNode };

export function HelpTip({ children }: Props) {
  return <aside className="help-tip" aria-label="Petunjuk">{children}</aside>;
}
